import { styles } from './GroupedImageToolOption.styles';
import { BaseButton } from '@photosi/rn-components/buttons/base-button/BaseButton';
import { FocusGroups } from '@photosi/rn-components/focus-provider/FocusProvider.constants';
import TextLato from '@photosi/rn-components/text/text-lato/TextLato';
import { Image } from 'expo-image';
import { GroupedImageToolOptionProps } from './GroupedImageToolOption.types';
import { getFormattedPrice } from 'src/helpers/price.helper';
import { generateTestID, lookupChoiceTestID } from 'src/helpers/testIDs.helper';
import { ToolOptionTooltip } from '../../../tool-option-tooltip/ToolOptionTooltip';
import { View } from 'react-native';
import { Icon } from '@photosi/rn-components/icon/Icon';
import { neutrals } from 'src/theme/colors';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import i18n from 'src/app/i18n';
import { TestIDs } from 'src/constants/testIDs.constants';

export const GroupedImageToolOption = ({
  index,
  optionCode,
  onPress,
  isActive,
  isPriceVisible,
  isSelected,
  isDisabled,
  previewImageUrl,
  title,
  price,
  hint,
  isSuboptimal,
}: GroupedImageToolOptionProps) => {
  const buttonTestID = lookupChoiceTestID(optionCode, index);

  return (
    <ToolOptionTooltip hint={hint}>
      <BaseButton
        style={[styles.button]}
        innerStyle={styles.buttonInner}
        focusStyle={styles.buttonFocus}
        testID={buttonTestID}
        onPress={onPress}
        focusId={buttonTestID}
        focusOrder={index}
        focusGroup={FocusGroups.TOOLBAR_OPTIONS}
        focusable={isActive}
        disabled={isDisabled}
        accessible={true}
        accessibilityRole="button"
        accessibilityLabel={title ?? `grouped image tool option ${buttonTestID}`}
      >
        {() => {
          return (
            <>
              {isSuboptimal && (
                <View style={[styles.subTag, isActive && { top: 2, left: 2 }]}>
                  <View style={styles.icon}>
                    <Icon name={ICON_NAMES.Alert} color={neutrals.white} />
                  </View>
                  <TextLato style={styles.subTagText}>{i18n.t('lookups:suboptimal')}</TextLato>
                </View>
              )}
              <Image
                // @ts-ignore
                crossOrigin="anonymous"
                source={previewImageUrl}
                contentFit="cover"
                style={[
                  styles.image,
                  !previewImageUrl && styles.imagePlaceholder,
                  isSelected && styles.imageActive,
                  isDisabled && styles.imageDisabled,
                ]}
                testID={generateTestID(buttonTestID, TestIDs.IMAGE_WRAPPER)}
              />
              {title && (
                <TextLato
                  style={[styles.text, isSelected && styles.textActive, isDisabled && styles.textDisabled]}
                  testID={generateTestID(buttonTestID, TestIDs.TITLE)}
                >
                  {title}
                </TextLato>
              )}
              {isPriceVisible && typeof price === 'number' && price > 0 && (
                <TextLato
                  style={[styles.text, isSelected && styles.textActive, isDisabled && styles.textDisabled]}
                  testID={generateTestID(buttonTestID, TestIDs.PRICE)}
                >
                  {getFormattedPrice({ price })}
                </TextLato>
              )}
            </>
          );
        }}
      </BaseButton>
    </ToolOptionTooltip>
  );
};

GroupedImageToolOption.displayName = 'GroupedImageToolOption';
